/**
 * Created by Rodrigo Quesada on 03/03/17.
 */
import {Component, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {ReplaySubject} from 'rxjs';
import {ActivatedRoute} from '@angular/router';
import {FormErrors} from '../../../../components/forms/validation/form-validator.class';
import {StepScreenModel} from '../../../shared/step/step-screen.component';
import {ReleaseSectionService} from '../../model/release-section.service';
import {ReleaseAuthorizationInfo} from '../../model/release-authorization-info.model';

@Component({
    template: require('./release-authorization-screen.component.html')
})
export class ReleaseAuthorizationScreenComponent {

    constructor(readonly releaseSectionService: ReleaseSectionService,
                readonly route: ActivatedRoute) {}

    // region Form
    readonly form$ = new ReplaySubject<NgForm>(1);

    @ViewChild(NgForm) set form(value: NgForm) {
        this.form$.next(value);
    }

    // endregion

    stepScreenModel = new StepScreenModel<ReleaseAuthorizationInfo>({
        initialDataModel: new ReleaseAuthorizationInfo(),
        specificValidationMessages: {},
        _loadDataFn: () => {
            return this.releaseSectionService.currentUserReleaseAuthorizationInfo();
        },
        _submitDataFn: (model: ReleaseAuthorizationInfo) => {
            return this.releaseSectionService.updateCurrentUserReleaseAuthorizationInfo(model);
        }
    });

    get model(): ReleaseAuthorizationInfo {
        return this.stepScreenModel.dataModel;
    }

    get formErrors(): FormErrors {
        return this.stepScreenModel.formErrors;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/release/steps/authorization/release-authorization-screen.component.ts